"use client"

import styles from "./styles/calendar.module.scss";
import FontAwesome from "../FontAwesome";
import React, {ReactElement} from "react";
import {IReactiveEventContentItem} from "../../../stores/SchoolFeedStore";
import moment from "moment-timezone";
import {currentDateFormat, currentMonthFormat} from "./utils";
import Event from "./Event";
import {useStores} from "../../../stores/useStores";

export function ListCalendar(props: {
    currentMonth: string,
    currentDate: string,
    setCurrentDate: (date: string) => void,
    events: IReactiveEventContentItem[],
    prevMonth: () => void,
    nextMonth: () => void,
    handleDeleteEvent: (event: IReactiveEventContentItem) => void,
    viewMoreButton?: ReactElement,
    isLoading?: boolean,
}) {
    const {modalStore} = useStores();

    const handleSelectEvent = (event) => {
        modalStore.addModal({
            type: "schoolBlocksEvent",
            event,
        });
    };

    let content;
    if (props.isLoading) {
        content = <div className={styles.dayEvent} style={{textAlign: "center", padding: "1rem"}}>
            <span><FontAwesome prefix={"fas"} spin name={"fa-spinner"} /> Loading events...</span>
        </div>
    } else if (props.events.length === 0) {
        content = <div className={styles.dayEvent} style={{textAlign: "center", padding: "1rem"}}>
            <span>No events for {moment(props.currentMonth, currentMonthFormat).format("MMMM, YYYY")}</span>
        </div>
    } else {
        content = <ul>
            {props.events.map(event => <Event
                key={event.id}
                event={event}
                currentDate={moment(props.currentDate, currentDateFormat)}
                onEventClick={handleSelectEvent}
                handleDelete={props.handleDeleteEvent}
            />)}
        </ul>
    }

    return <div className={styles.eventListContainer}>
        <div className={styles.listControls}>
            <button onClick={props.prevMonth}>
                <FontAwesome prefix={"fas"} name={"fa-chevron-left"}/> Prev
                Month
            </button>
            |{" "}
            <button onClick={props.nextMonth}>
                Next Month{" "}
                <FontAwesome prefix={"fas"} name={"fa-chevron-right"}/>
            </button>
        </div>
        {content}
        <div className={styles.viewMoreButton}>
            {props.viewMoreButton}
        </div>
    </div>
}